import { Component, OnInit } from "@angular/core";
import { RouterLink } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";
import { LayoutComponent } from "../../shared/layout/layout.component";
import { BreadcrumbComponent } from "../../shared/breadcrumb/breadcrumb.component";
import { TitleComponent } from "../../shared/title/title.component";
import { ButtonComponent } from "../../shared/button/button.component";
import { SpinnerComponent } from "../../shared/icons/spinner/spinner.component";
import { GigyaService } from "../../services/gigya.service";

@Component({
  selector: "app-email-confirmed",
  standalone: true,
  imports: [
    TranslatePipe,
    RouterLink,
    LayoutComponent,
    BreadcrumbComponent,
    TitleComponent,
    ButtonComponent,
    SpinnerComponent,
  ],
  templateUrl: "./email-confirmed.component.html",
  styleUrl: "./email-confirmed.component.css",
})
export class EmailConfirmedComponent implements OnInit {
  isLoggedIn: boolean | null = null;

  constructor(
    private gigyaService: GigyaService,
  ) {}

  async ngOnInit(): Promise<void> {
    const res = await this.gigyaService.execute(this.gigyaService.client.accounts.getAccountInfo, {});
    this.isLoggedIn = res.errorCode === 0;
  }
}
